/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Layout } from '@components';
import { ThemeProvider as CustomThemeProvider } from '@contexts/ThemeContext';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from '@styles';

// Replace ReactDOM.render with createRoot for React 18
export const replaceHydrateFunction = () => (element, container) => {
  const root = createRoot(container);
  root.render(element);
};

// Wrap all pages with ThemeProvider and Globalstyle
export const wrapRootElement = ({ element }) => (
  <CustomThemeProvider>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {element}
    </ThemeProvider>
  </CustomThemeProvider>
);

// Wrap all pages with Layout
export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
